// extracted by mini-css-extract-plugin
export default {"LoginMain":"login_LoginMain__RUvNw","LoginForm":"login_LoginForm__GPDS8","LoginButton":"login_LoginButton__gk5gC"};